import React from 'react'
import {connect} from 'react-redux'

import ProfileBasic from '../components/ProfileBasic'
import actions from '../actions/profileBasic'
import changeEmailActions from '../actions/changeEmail'
import changePhoneActions from '../actions/changePhone'
import changePasswordActions from '../actions/changePassword'

class ProfileBasicContainer extends React.Component {

  save = () => {
    if (this.props.email.changed === true) {
      this.props.saveEmail()
        .then(success => {
          if (success === true) this.props.saveBasic()
        })
    } else {
      this.props.saveBasic()
    }
  }

  render() {
    return <ProfileBasic {...this.props} save={this.save}/>
  }
}

ProfileBasicContainer.propTypes = {}

const mapStateToProps = state => {
  console.log(state)
  const data = state.ui.profile.profileBasic
  const changeEmailData = state.ui.profile.changeEmail
  const changePhoneData = state.ui.profile.changePhone
  const changePasswordData = state.ui.profile.changePassword
  const fbUser = state.domain.user.fbUser

  return {
    name: {
      value: data.getIn(['name', 'value']),
      error: data.getIn(['name', 'error']),
    },
    lastName: {
      value: data.getIn(['lastName', 'value']),
      error: data.getIn(['lastName', 'error']),
    },
    picture: {
      value: data.getIn(['picture', 'value']),
      error: data.getIn(['picture', 'error']),
    },
    email: {
      value: changeEmailData.getIn(['email', 'value']),
      error: changeEmailData.getIn(['email', 'error']),
      changed: changeEmailData.getIn(['email', 'changed']),
    },
    number: {
      value: changePhoneData.getIn(['number', 'value']),
      error: changePhoneData.getIn(['number', 'error']),
    },
    phoneDialog: {
      show: changePhoneData.getIn(['dialog', 'show']),
      code: {
        value: changePhoneData.getIn(['dialog', 'code', 'value']),
        error: changePhoneData.getIn(['dialog', 'code', 'error']),
      },
      isSaving: changePhoneData.getIn(['dialog', 'isSaving']),
      isSending: changePhoneData.getIn(['dialog', 'isSending']),
      error: changePhoneData.getIn(['dialog', 'error']),
    },
    currentPassword: {
      value: changePasswordData.getIn(['currentPassword', 'value']),
      error: changePasswordData.getIn(['currentPassword', 'error']),
    },
    newPassword: {
      value: changePasswordData.getIn(['newPassword', 'value']),
      error: changePasswordData.getIn(['newPassword', 'error']),
    },
    confirmPassword: {
      value: changePasswordData.getIn(['confirmPassword', 'value']),
      error: changePasswordData.getIn(['confirmPassword', 'error']),
    },
    passwordDialog: {
      show: changePasswordData.getIn(['dialog', 'show']),
      error: changePasswordData.get('error'),
      isSaving: changePasswordData.get('isSaving'),
    },
    isSaving: data.get('isSaving'),
    error: data.get('error'),
    fbUser
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setName: value => dispatch(actions.setName(value)),
    setLastName: value => dispatch(actions.setLastName(value)),
    saveBasic: () => dispatch(actions.save()),
    setPicture: value => dispatch(actions.setPicture(value)),
    setFile: file => dispatch(actions.setFile(file)),
    savePicture: () => dispatch(actions.savePicture()),
    setEmail: value => dispatch(changeEmailActions.setEmail(value)),
    saveEmail: () => dispatch(changeEmailActions.save()),
    setNumber: number => dispatch(changePhoneActions.setNumber(number)),
    setPhoneCode: code => dispatch(changePhoneActions.setCode(code)),
    sendPhoneCode: () => dispatch(changePhoneActions.sendCode()),
    setOpenPhoneDialog: show => dispatch(changePhoneActions.setOpenDialog(show)),
    saveNumber: () => dispatch(changePhoneActions.save()),
    setOpenPasswordDialog: show => dispatch(changePasswordActions.setOpenDialog(show)),
    setCurrentPassword: password => dispatch(changePasswordActions.setCurrentPassword(password)),
    setNewPassword: password => dispatch(changePasswordActions.setNewPassword(password)),
    setConfirmPassword: password => dispatch(changePasswordActions.setConfirmPassword(password)),
    savePassword: () => dispatch(changePasswordActions.save()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileBasicContainer)



// WEBPACK FOOTER //
// ./src/sections/profile/containers/profileBasic.js